import cn from 'classnames';
import i18n from '@/settings/i18n';
import RenderedLink from './RenderedLink';
import { useCollectionPageContext } from '../hooks/useCollectionPageContext';
import { generateCategoryPageUrl } from '../hooks/helpers';

const t = i18n.init('categories');

export default function Breadcrumb() {
  const { breadcrumb, pk } = useCollectionPageContext();

  if (!breadcrumb || (breadcrumb && breadcrumb.length === 0)) {
    return null;
  }

  return (
    <div className="xl:reebelo-container mx-auto -mb-2.5 hidden md:block md:px-5 md:pt-5 xl:px-8">
      <div className="flex items-center gap-1 text-xs">
        <div className="flex items-center gap-1">
          <RenderedLink link="/" title={t`Home`} />
          <span className="block text-gray-700/50">/</span>
        </div>
        {breadcrumb.map((c) => {
          if (pk && c.pk === pk) {
            return (
              <div
                className="flex items-center capitalize"
                key={`${c.name}-${c.pk}`}
              >
                <span>{t(c.name)}</span>
              </div>
            );
          }
          const link = generateCategoryPageUrl(c.name, c.pk);

          return (
            <div key={c.name} className="group flex items-center gap-1">
              <RenderedLink link={link} title={t(c.name)} />
              <span className={cn('block text-gray-700/50')}>/</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
